<template>
    <div>
        <gofix-card title="General Settings">
            <template slot="gofixCard:right_header">
                <span class="editBox position-static cursor-pointer" @click="modalEdit('general')">
                    <img src="img/iconPencil.png" alt  width="18" height="18"/>
                </span>
            </template>
            <b-row>
                <b-col class="mb-2" cols="12" lg=4>
                    <gofix-text-field class="mb-2" classLabel="width-215" label="Allow Help Desk to Raise WO" oneline>
                        {{ setting.is_allow_help_desk_raise_wo ? "Yes" : "No" }}
                    </gofix-text-field>
                </b-col>
                <b-col class="mb-2" cols="12" lg=4>
                    <gofix-text-field class="mb-2" classLabel="width-240" label="Allow Contractor to add line items" oneline>
                        {{ setting.is_allow_contractor_add_line_items ? "Yes" : "No" }}
                    </gofix-text-field>
                </b-col>
                <b-col class="mb-2" cols="12" lg=4>
                    <gofix-text-field class="mb-2" classLabel="width-240" label="Mobile: Allow uploading photos from gallery" oneline>
                        {{ setting.is_allow_uploading_photos_gallery_mobile ? "Yes" : "No" }}
                    </gofix-text-field>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="mb-2" cols="12" lg=4>
                    <gofix-text-field classLabel="width-215" label="Contractor Authorization Limit" oneline>
                        {{ setting.contractor_authorization_limit ? setting.contractor_authorization_limit : "" | formatMoney }}
                    </gofix-text-field>
                </b-col>
                <b-col class="mb-2" cols="12" lg=4>
                    <gofix-text-field classLabel="width-240" label="Allow to change in SOR once WO is completed" oneline>
                        {{ setting.is_allow_change_sor_rwo_completed ? "Yes" : "No" }}
                    </gofix-text-field>
                </b-col>
                <b-col class="mb-2" cols="12" lg=4>
                    <gofix-text-field classLabel="width-240" label="Allow Issue Register to show Lift Inspection Report button" oneline>
                        {{ setting.is_allow_issue_register_show_lift_inspection_report_button ? "Yes" : "No" }}
                    </gofix-text-field>
                </b-col>
            </b-row>
            <b-row>  
                <b-col class="mb-2" cols="12" lg=4>
                    <gofix-text-field class="mb-2" classLabel="width-215" label="Job Geo-fencing" oneline>
                        {{ setting.job_geo_fencing ? setting.job_geo_fencing + " (m)" : '--'}}
                    </gofix-text-field>
                </b-col>
                <b-col class="mb-2" cols="12" lg=4>
                    <gofix-text-field class="mb-2" classLabel="width-240" label="Order Geo-fencing" oneline>
                        {{ setting.order_geo_fencing ? setting.order_geo_fencing + " (m)" : '--'}}
                    </gofix-text-field>
                </b-col>
                <b-col class="mb-2" cols="12" lg=4>
                    <gofix-text-field class="mb-2" classLabel="width-240" label="Allow WO Change Issued To Completed" oneline>
                        {{ setting.is_allow_wo_issued_to_completed ? "Yes" : "No" }}
                    </gofix-text-field>
                </b-col>
            </b-row>
            <b-row> 
                <b-col class="mb-2" cols="12" lg="4">
                    <gofix-text-field classLabel="width-215" label="Do not allow raising RWO from Case with status" oneline>
                        {{ setting.do_not_allow_raising_rwo_from_case_with_status ? setting.do_not_allow_raising_rwo_from_case_with_status.join(', ') : "--"}}
                    </gofix-text-field>
                </b-col>
                <b-col class="mb-2" cols="12" lg="4">
                    <gofix-text-field classLabel="width-240" label="Allows adding delivery orders with WO status" oneline>
                        {{ setting.allows_adding_delivery_orders_with_order_status ? setting.allows_adding_delivery_orders_with_order_status.join(', ') : "--"}}
                    </gofix-text-field>
                </b-col>
                <b-col class="mb-2" cols="12" lg=4>
                    <gofix-text-field class="mb-2" classLabel="width-240" label="Allow PWO dispatch to Supplier without Approval from Joblist" oneline>
                        {{ setting.is_allow_pwo_dispatch_to_supplier_without_approval ? "Yes" : "No" }}
                    </gofix-text-field>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="mb-2" cols="12" lg=4>
                    <gofix-text-field class="mb-2" classLabel="width-215" label="Exclude WO/PV requestor/submitter/creator from 1st level approver" oneline>
                        {{ setting.is_exclude_1st_level_approver ? "Yes" : "No" }}
                    </gofix-text-field>
                </b-col>
                <b-col class="mb-2" cols="12" lg=4>
                    <gofix-text-field class="mb-2" classLabel="width-240" label="Enable Auto Approval" oneline>
                        {{ setting.is_enable_auto_approval ? "Yes" : "No" }}
                    </gofix-text-field>
                </b-col>
                <b-col class="mb-2" cols="12" lg=4>
                    <gofix-text-field class="mb-2" classLabel="width-240" label="Allow to change the Supplier after WO is sent for approval" oneline>
                        {{ setting.is_allow_change_supplier_after_wo_approved ? "Yes" : "No" }}
                    </gofix-text-field>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="mb-2" cols="12" lg=4>
                    <gofix-text-field class="mb-2" classLabel="width-215" label="Do not Allow Automatically Complete WO when DO is Full Delivery" oneline>
                        {{ setting.is_do_not_allow_auto_complete_wo_when_add_do ? "Yes" : "No" }}
                    </gofix-text-field>
                </b-col>
                <b-col class="mb-2" cols="12" lg=4>
                    <gofix-text-field class="mb-2" classLabel="width-240" label="CWO: Allow auto assign Supplier" oneline>
                        {{ setting.is_allow_auto_assign_supplier ? "Yes" : "No" }}
                    </gofix-text-field>
                </b-col>
                <b-col class="mb-2" cols="12" lg=4>
                    <gofix-text-field class="mb-2" classLabel="width-240" label="CWO: Allow auto assign FM Officer In Charge" oneline>
                        {{ setting.is_allow_auto_assign_fm_officer_in_charge ? "Yes" : "No" }}
                    </gofix-text-field>
                </b-col>
            </b-row>    
             
            <!-- softfm_job_days_range_last_to_upcoming -->
            <b-modal :no-close-on-backdrop="true" modal-class="createFmCode" id="modal-Create" :title="modal.title" hide-footer :centered="true" v-model="modal.open">
                <b-form class="pb-20">
                    <b-form-checkbox v-model="modal.data.is_allow_help_desk_raise_wo" class="ml-3 mb-26"><span class="ml-21">Allow Help Desk to Raise WO</span></b-form-checkbox>
                    <b-form-checkbox v-model="modal.data.is_allow_contractor_add_line_items" class="ml-3 mb-26"><span class="ml-21">Allow Contractor to add line items</span></b-form-checkbox>
                    <b-form-checkbox v-model="modal.data.is_allow_uploading_photos_gallery_mobile" class="ml-3 mb-26"><span class="ml-21">Mobile: Allow uploading photos from gallery</span></b-form-checkbox>
                    <b-form-checkbox v-model="modal.data.is_allow_change_sor_rwo_completed" class="ml-3 mb-26"><span class="ml-21">Allow to change in SOR once WO is completed</span></b-form-checkbox>
                    <b-form-checkbox v-model="modal.data.is_allow_issue_register_show_lift_inspection_report_button" class="ml-3 mb-26"><span class="ml-21">Allow Issue Register to show Lift Inspection Report button</span></b-form-checkbox>
                    <b-form-checkbox v-model="modal.data.is_allow_wo_issued_to_completed" class="ml-3 mb-26"><span class="ml-21">Allow WO Change Issued To Completed</span></b-form-checkbox>
                    <b-form-checkbox v-model="modal.data.is_exclude_1st_level_approver" class="ml-3 mb-26"><span class="ml-21">Exclude WO/PV requestor/submitter/creator from 1st level approver</span></b-form-checkbox>
                    <b-form-checkbox v-model="modal.data.is_enable_auto_approval" class="ml-3 mb-26"><span class="ml-21">Enable Auto Approval</span></b-form-checkbox>
                    <b-form-checkbox v-model="modal.data.is_allow_change_supplier_after_wo_approved" class="ml-3 mb-26"><span class="ml-21">Allow to change the Supplier after WO is sent for approval</span></b-form-checkbox>
                    <b-form-checkbox v-model="modal.data.is_allow_pwo_dispatch_to_supplier_without_approval" class="ml-3 mb-26"><span class="ml-21">Allow PWO dispatch to Supplier without Approval from Joblist</span></b-form-checkbox>
                    <b-form-checkbox v-model="modal.data.is_do_not_allow_auto_complete_wo_when_add_do" class="ml-3 mb-26"><span class="ml-21">Do not Allow Automatically Complete WO when DO is Full Delivery</span></b-form-checkbox>
                    <b-form-checkbox v-model="modal.data.is_allow_auto_assign_supplier" class="ml-3 mb-26"><span class="ml-21">CWO: Allow auto assign Supplier</span></b-form-checkbox>
                    <b-form-checkbox v-model="modal.data.is_allow_auto_assign_fm_officer_in_charge" class="ml-3 mb-26"><span class="ml-21">CWO: Allow auto assign FM Officer In Charge</span></b-form-checkbox>
                    <gofix-form-input-number
                        label="Contractor Authorization Limit"
                        v-model="modal.data.contractor_authorization_limit"
                        prefix="$">
                    </gofix-form-input-number>
                    <gofix-form-dropdown
                        label="Do not allow raising RWO from Case with status"
                        multiple
                        append-to-body
                        v-model="modal.data.do_not_allow_raising_rwo_from_case_with_status"
                        :options='["Open", "Assigned", "PIC Acknowledged", "RWO Issued", "Completed"]'
                    >
                    </gofix-form-dropdown>
                    <gofix-form-dropdown
                        label="Allows adding delivery orders with WO status"
                        multiple
                        append-to-body
                        v-model="modal.data.allows_adding_delivery_orders_with_order_status"
                        :options='["Issued","Under Approval","Pending Revision","Approved","Dispatched","Acknowledged","On-Site","Partially Completed","Completed","Invoiced"]'
                    >
                    </gofix-form-dropdown>
                    <gofix-form-input-number
                        label="Job Geo-fencing"
                        desc="Max Radius (m) - empty box means no geo-fencing"
                        v-model="modal.data.job_geo_fencing"
                        :include-thousands-separator="false" >
                    </gofix-form-input-number>
                    <gofix-form-input-number
                        label="Order Geo-fencing"
                        desc="Max Radius (m) - empty box means no geo-fencing"
                        v-model="modal.data.order_geo_fencing"
                        :include-thousands-separator="false" >
                    </gofix-form-input-number>
   
                    <!-- softfm_job_days_range_last_to_upcoming -->
                </b-form>
                <b-button-group class="d-block text-right">
                    <gofix-button label="SUBMIT" @click="save" :loading="modal.loading" noBorder></gofix-button>
                </b-button-group>
            </b-modal>
        </gofix-card>
        <gofix-card title="Finance Settings">
            <template slot="gofixCard:right_header">
                <span class="editBox position-static cursor-pointer" @click="modalEdit('financial')">
                    <img src="img/iconPencil.png" alt  width="18" height="18"/>
                </span>
            </template>
            <b-row>
                <b-col cols="12" lg=4>
                    <gofix-text-field class="mb-2" label="FM Code mandatory" oneline>
                        {{ setting.is_required_fm_code ? "Yes" : "No" }}
                    </gofix-text-field>
                </b-col>
                <b-col cols="12" lg=4>
                    <gofix-text-field class="mb-2" label="GL Code mandatory" oneline>
                        {{ setting.is_required_gl_code ? "Yes" : "No" }}
                    </gofix-text-field>
                </b-col>
                <b-col cols="12" lg=4>
                    <gofix-text-field class="mb-2" label="Exclude Journal Entries and Navision" oneline>
                        {{ setting.exclude_journal_entries_navision ? "Yes" : "No" }}
                    </gofix-text-field>
                </b-col>
            </b-row>
            <b-modal :no-close-on-backdrop="true" modal-class="createFmCode" id="modal-Create" :title="modal.title" hide-footer :centered="true" v-model="modal.financial.open">
                <b-form class="pb-20">
                    <b-form-checkbox v-model="modal.data.is_required_gl_code" class="ml-3 mb-26"><span class="ml-21">GL Code mandatory</span></b-form-checkbox>
                    <b-form-checkbox v-model="modal.data.is_required_fm_code" class="ml-3 mb-26"><span class="ml-21">FM Code mandatory</span></b-form-checkbox>
                    <b-form-checkbox v-model="modal.data.exclude_journal_entries_navision" class="ml-3 mb-26"><span class="ml-21">Exclude Journal Entries and Navision</span></b-form-checkbox>
                </b-form>
                <b-button-group class="d-block text-right">
                    <gofix-button label="SUBMIT" @click="save" :loading="modal.loading" noBorder></gofix-button>
                </b-button-group>
            </b-modal>
        </gofix-card>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    const accounting = require('accounting');
    export default {
        name: 'general-settings',
        components: {},
        data () {
            return {
                setting: {
                    is_allow_help_desk_raise_wo: false,
                    is_allow_contractor_add_line_items: false,
                    is_allow_uploading_photos_gallery_mobile:false,
                    is_allow_change_sor_rwo_completed:false,
                    is_allow_issue_register_show_lift_inspection_report_button:false,
                    is_allow_wo_issued_to_completed:false,
                    contractor_authorization_limit: "",
                    do_not_allow_raising_rwo_from_case_with_status: [],
                    job_geo_fencing: null,
                    order_geo_fencing: null,
                    is_required_gl_code: false,
                    is_required_fm_code: false,
                    is_enable_auto_approval: false,
                    is_exclude_1st_level_approver: false,
                    is_allow_change_supplier_after_wo_approved:false,
                    allows_adding_delivery_orders_with_order_status:[],
                    is_allow_pwo_dispatch_to_supplier_without_approval:false,
                    is_do_not_allow_auto_complete_wo_when_add_do:false,
                    exclude_journal_entries_navision:false,
                    is_allow_auto_assign_supplier: false,
                    is_allow_auto_assign_fm_officer_in_charge: false,
                    
                },
                modal:{
                    open: false,
                    loading: false,
                    timer: null,
                    title:"Edit General Settings",
                    financial: {
                        title: 'Edit Financial Settings',
                        open: false,
                    },
                    data:{
                        is_allow_help_desk_raise_wo: false,
                        is_allow_contractor_add_line_items: false,
                        is_allow_uploading_photos_gallery_mobile:false,
                        is_allow_change_sor_rwo_completed:false,
                        is_allow_issue_register_show_lift_inspection_report_button:false,
                        is_allow_wo_issued_to_completed:false,
                        contractor_authorization_limit: "",
                        do_not_allow_raising_rwo_from_case_with_status: [],
                        job_geo_fencing: null,
                        order_geo_fencing: null,
                        is_required_gl_code: false,
                        is_required_fm_code: false,
                        is_enable_auto_approval: false,
                        is_exclude_1st_level_approver: false,
                        is_allow_change_supplier_after_wo_approved:false,
                        allows_adding_delivery_orders_with_order_status:[],
                        is_allow_pwo_dispatch_to_supplier_without_approval:false,
                        is_do_not_allow_auto_complete_wo_when_add_do:false,
                        exclude_journal_entries_navision:false,
                        is_allow_auto_assign_supplier: false,
                        is_allow_auto_assign_fm_officer_in_charge: false,
                    },
                },
            }
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID',
            }),
        },
        watch: {
            ClientContractID: function(val) {
                if(val && val.settings) {
                    this.setting = Object.assign(this.setting, val.settings);
                } else {
                    this.setting = {
                        is_allow_help_desk_raise_wo: false,
                        is_allow_contractor_add_line_items: false,
                        is_allow_uploading_photos_gallery_mobile:false,
                        is_allow_contractor_add_line_items:false,
                        is_allow_wo_issued_to_completed:false,
                        contractor_authorization_limit: "",
                        do_not_allow_raising_rwo_from_case_with_status: [],
                        job_geo_fencing: null,
                        order_geo_fencing: null,
                        is_required_gl_code: false,
                        is_required_fm_code: false,
                        is_enable_auto_approval: false,
                        is_exclude_1st_level_approver: false,
                        is_allow_change_supplier_after_wo_approved:false,
                        allows_adding_delivery_orders_with_order_status:[],
                        is_allow_pwo_dispatch_to_supplier_without_approval:false,
                        is_do_not_allow_auto_complete_wo_when_add_do:false,
                        exclude_journal_entries_navision:false,
                        is_allow_auto_assign_supplier: false,
                        is_allow_auto_assign_fm_officer_in_charge: false,
                    }
                }
            }
        },
        created() {
            if(this.ClientContractID && this.ClientContractID.settings) {
                this.setting = Object.assign(this.setting, this.ClientContractID.settings);
            }
        },
        methods:{
            modalEdit(type) {
                this.modal.data = Object.assign(this.modal.data, this.setting);
                this.modal.loading = false;
                if(type == "general") 
                    this.modal.open = true;
                else
                    this.modal.financial.open = true;
            },
            save(){
                if (this.modal.timer) {
                    clearTimeout(this.modal.timer);
                    this.modal.timer = null;
                }
                this.modal.timer = setTimeout(async () => {
                    this.modal.loading = true;
                    let objClone = {
                        contract_id: this.ClientContractID.id,
                        client_id: this.ClientContractID.client_id,
                        supplier_id: this.ClientContractID.supplier_id,
                        contract_name: this.ClientContractID.contract_name,
                        abbreviation: this.ClientContractID.abbreviation,
                        description: this.ClientContractID.description,
                        deposit_amount: this.ClientContractID.deposit_amount,
                        issuing_bank: this.ClientContractID.issuing_bank,
                        deposit_expiry: this.ClientContractID.deposit_expiry,
                        insurance_expiry: this.ClientContractID.insurance_expiry,
                        insurance_excess: this.ClientContractID.insurance_excess,
                        insurance_type: this.ClientContractID.insurance_type,
                        timezone: this.ClientContractID.timezone,
                        settings: this.modal.data
                    }

                    objClone.settings.contractor_authorization_limit = accounting.unformat(objClone.settings.contractor_authorization_limit);
                    objClone.settings = JSON.stringify(objClone.settings);
                    this.$store.dispatch('ContractController/UpdateClientContract', objClone)
                    .then(response => {
                        this.modal.loading = false;
                        this.modal.open = false;
                        this.modal.financial.open = false;
                        this.setting = Object.assign(this.setting, this.modal.data)
                        this.$store.dispatch('ContractController/getClientContractID', objClone.contract_id);
                        this.$alertNotification(this.$notificationV2('editing', 'client_contract_setting'));
                    })
                    .catch(error => {
                        this.modal.loading = false;
                    });
                }, 200);
            },
        }
    }
</script>
